import MainComponent from "components/Main";

import Input from "components/Input";
import SumInput from "components/SumInput";
import ButtonIconSelect from "components/ButtonIconSelect";

import { ReactComponent as NotificationStopSaleIcon } from 'icons/components/notificationStopsale.svg';
import { ReactComponent as MakeGroupIcon } from 'icons/components/makeGroup.svg';
import { ReactComponent as ArrowRightSIcon } from 'icons/components/arrowRightS.svg';
import { ReactComponent as DragIcon } from 'icons/components/drag.svg';
import { ReactComponent as CloseIcon } from 'icons/components/bufferClose.svg';
import { ReactComponent as CheckIcon } from 'icons/components/check.svg';
import { ReactComponent as NotificationPillsIcon } from 'icons/components/notificationPills.svg';

import '../index.less';
import '../themes/default.less';

export default class Row extends MainComponent {

    constructor(props) {
        super(props);

        this.priceNodes = {};

        this.state = {
            ...this.state,
            editCode: "",
            editName: "",
            editSum: "",
            editRow: false,
        };
    }

    toggleEditRow(event, mode, code, name, sum) {
        if (event === "+") {
            const editRow = mode;
            const editCode = code;
            const editName = name;
            const editSum = sum;

            this.setState({ editRow, editCode, editName, editSum });
        } else
            this.changeState("editRow", false);

    }

    renderDragButt(source, id) {
        return (<div
            className="drag move"
            onMouseDown={this.props.info.onEnableDrag.bind(this)}
            onMouseUp={this.props.info.onDisableDrag.bind(this)}
        >
            <DragIcon />
        </div>);
    }

    saveValue(info) {
        const { editRow, editCode, editName, editSum } = this.state;
        this.props.info.saveChange({ ...info, editCode, editName, editSum }, editRow);
        this.toggleEditRow("-");
    }

    renderEditButton(info, editRow) {
        return (<div className="buttEdit flex">
            <div className="flex1 flex centerH centerV hand" onClick={this.toggleEditRow.bind(this, "-")}><CloseIcon /></div>
            <div className="flex1 flex centerH centerV hand" onClick={this.saveValue.bind(this, info)}><CheckIcon /></div>
        </div>);
    }

    render() {
        const { editRow, editCode, editName, editSum } = this.state;
        const { id: origId, name, altCode, value, noDiscount, tempId, modePrice,
            searchWord, deleteItem, copyItem, onDragOver, onDragStart,
            onDrop, enableDrag, categoryTitle, convertGroup } = this.props.info;
        const sum = this._helper.number.toSum(value);
        const id = origId || tempId;
        const showPills = (categoryTitle === "Препараты и материалы");

        return (
            <div
                ref={el => this[`subItem${id}`] = el}
                className={`subItem flex gap16 text p1 centerV draggable`}
                draggable={enableDrag ? "true" : "false"}
                onDragOver={onDragOver.bind(this)}
                onDragStart={onDragStart.bind(this)}
                onDrop={onDrop.bind(this)}
                data-id={id}
            >
                <div className="name flex flex1 gap8 centerV">
                    {modePrice === "edit" && editRow !== "all" && !searchWord && this.renderDragButt("subItem", id)}
                    {editRow === "all" ?
                        <div className="inpaltcode">
                            <Input value={editCode} onChange={this.changeState.bind(this, "editCode")} />
                        </div> :
                        <div className="info gray selectable">{altCode}</div>}
                    {editRow === "all" ?
                        <div className="inpname flex1">
                            <Input onChange={this.changeState.bind(this, "editName")} value={editName} />
                        </div> :
                        <div className="name selectable flex gap8">
                            <div>{name}</div>
                            {showPills && <div className="flex centerAll"><NotificationPillsIcon /></div>}
                        </div>}
                </div>
                <div className="flex gap8 centerV">
                    {noDiscount && <div><NotificationStopSaleIcon /></div>}
                    {editRow ?
                        <div className="inpsum"><SumInput onChange={this.changeState.bind(this, "editSum")} value={editSum} /></div> :
                        <div className="sum flex end selectable" onDoubleClick={modePrice === "edit" ?
                            this.toggleEditRow.bind(this, "+", "sum", altCode, name, value) : null}>{sum}</div>}
                    {modePrice === "edit" && (editRow ? this.renderEditButton(this.props.info, editRow) :
                        <div className="buttSel flex end">
                            <ButtonIconSelect
                                translate={true}
                                items={[
                                    { name: "price.copy", onClick: copyItem.bind(this, id) },
                                    { name: "main.edit", onClick: this.toggleEditRow.bind(this, "+", "all", altCode, name, value) },
                                    { name: "client.delete", onClick: deleteItem.bind(this, id) },
                                    { line: true },
                                    { name: "price.discountBan", rightIcon: <NotificationStopSaleIcon />, onClick: null },
                                    { name: "price.convertGroup", rightIcon: <MakeGroupIcon />, onClick: convertGroup.bind(this, id) },
                                    { line: true },
                                    { name: "price.moveStart", rightIcon: <ArrowRightSIcon className="icon rotate90m" />, onClick: null },
                                    { name: "price.moveEnd", rightIcon: <ArrowRightSIcon className="icon rotate90" />, onClick: null },
                                ]}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
